import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import LeftBar from "components/Layouts/LeftBar";

import Reports from "components/Reports";
import Masters from "components/Masters";
import Transactions from "components/Transactions";
import Dashboard from "components/Dashboard";
import Trips from "components/Transactions/Trips";
import TripPayment from "components/Transactions/TripPayment";
import Odometer from "components/Transactions/Odometer";
import Vehicles from "components/Masters/Vehicles";
import Drivers from "components/Masters/Drivers";
import Users from "components/Masters/Users";
import Settings from "components/Settings";
import HomeSkeleton from "./HomeSkeleton";
import Fuel from "components/Transactions/Fuel";
import Placement from "components/Transactions/Placement";
import MapPage from "components/MapPage";
import MyMap from "components/MyMap";
// import Roi from "components/Masters/ROI";
import TripReceipt from "components/Transactions/TripReceipt";

import { ApiLogin } from "apihandlers//login";
import { CONFIG, LOCAL_STORAGE } from "common/config";
import { LABELS, TITLES } from "common/labels";

import "./styles/home.css";

const API_HANDLER = new ApiLogin();

const imgLogo = require("assets/images/logo.png");

const HomePage = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<any>({});
  const [page, setPage] = useState(LABELS.HOME);

  useEffect(() => {
    // console.log("Home: userEffect: state: ", loading);
    if (loading) {
      checkLogin();
    }
  }, [loading]);

  const checkLogin = () => {
    const args = {};
    API_HANDLER.checkLogin(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      // console.log("checkLogin: ", res);
      if (status === 200) {
        if (response.status) {
          let userInfo = localStorage.getItem(LOCAL_STORAGE.USER_INFO);
          if (userInfo) {
            userInfo = JSON.parse(userInfo);
            setUserInfo(userInfo);
          }
          console.log("userInfo", userInfo);
          setLoading(false);
          setPage(LABELS.HOME);
        } else {
          window.open("/login", "_self");
        }
      }
    });
  };

  const reportsRef: any = useRef({});
  const dashboardRef: any = useRef({});
  const mastersRef: any = useRef({});
  const transactionsRef: any = useRef({});

  const onSetPage = (val = "") => {
    if (val === LABELS.REPORTS) {
      if (reportsRef.setMenu) {
        reportsRef.setMenu();
      }
    }
    // if (val === LABELS.REPORTS) {
    //   reportsRef.setMenu();
    // } else if  (val === LABELS.DASHBOARD) {
    //   dashboardRef.setMenu();
    // } else if  (val === LABELS.MASTERS) {
    //   mastersRef.setMenu();
    // } else if  (val === LABELS.TRANSACTIONS) {
    //   transactionsRef.setMenu();
    // }
    setPage(val);
  };

  console.log("page: ", page);

  return (
    <div
      className={"homeContainer " + (page === LABELS.HOME ? "" : "")}
      style={{
        overflow: page === LABELS.GANTT_CHART ? "none" : "auto",
      }}
    >
      {loading ? (
        <HomeSkeleton />
      ) : (
        <React.Fragment>
          <LeftBar setPage={onSetPage} page={page} userInfo={userInfo} />
          <div className="content">
            {page === LABELS.HOME && <MapPage />}
            {/* {page === LABELS.HOME && (
              <div className="welcomeBox">
                <div style={{ marginRight: 10 }} className="flexRowCenter">
                  <img
                    src={imgLogo}
                    height={100}
                    style={{
                      background: "#fff",
                      borderRadius: 4,
                    }}
                  />
                </div>
                <div className="flexColumn">
                  <h4
                    className="shadowTxt fontXL"
                    style={{
                      marginTop: 35,
                      textAlign: "left",
                    }}
                  >
                    {CONFIG.SITE_NAME}
                  </h4>
                  <h4
                    className="shadowTxt fontL"
                    style={{ marginTop: 0, textAlign: "left", paddingTop: 10 }}
                  >
                    Welcome!
                  </h4>
                </div>
              </div>
            )} */}
            {page === LABELS.REPORTS && (
              <Reports
                childRef={reportsRef}
                userInfo={userInfo}
                setPageMenu={setPage}
              />
            )}
            {/* {page === LABELS.DASHBOARD && (
              <Dashboard childRef={dashboardRef} userInfo={userInfo} />
            )} */}
            {page === LABELS.MASTERS && (
              <Masters
                childRef={mastersRef}
                userInfo={userInfo}
                setPageMenu={setPage}
              />
            )}

            {page === LABELS.TRANSACTIONS && (
              <Transactions
                childRef={transactionsRef}
                userInfo={userInfo}
                setPageMenu={setPage}
              />
            )}
            {page === LABELS.TRIPS && (
              <Trips
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.TRANSACTIONS);
                  }
                }}
              />
            )}
            {page === LABELS.PLACEMENT && (
              <Placement
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.TRANSACTIONS);
                  }
                }}
              />
            )}
            {page === LABELS.TRANSACTION_BUTTON_FUEL && (
              <Fuel
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.TRANSACTIONS);
                  }
                }}
              />
            )}
            {page === LABELS.MASTERS_BUTTON_VEHICLES && (
              <Vehicles
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.MASTERS);
                  }
                }}
              />
            )}
            {page === LABELS.MASTERS_BUTTON_DRIVERS && (
              <Drivers
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.MASTERS);
                  }
                }}
              />
            )}
            {page === LABELS.TRANSACTION_BUTTON_ODO && <Odometer />}
            {page === LABELS.TRANSACTION_BUTTON_TRIP_PAYMENT && <TripPayment />}
            {page === LABELS.TRANSACTION_BUTTON_EXPENSE_RECEIPT && (
              <TripReceipt />
            )}
            {page === LABELS.MASTERS_BUTTON_USERS && <Users />}
            {page === LABELS.SETTINGS && (
              <Settings
                userInfo={userInfo}
                setDashMenu={(menu) => {
                  if (menu === "") {
                    setPage(LABELS.HOME);
                  } else {
                    setPage(LABELS.MASTERS);
                  }
                }}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default withSnackbar(HomePage);
